var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/savemodulelocks',["require", "exports", "common/parts", "areas/navigationmanager/services/navigationrepository"], function (require, exports, Parts, Repository) {
    "use strict";
    var SaveModuleLocks = (function (_super) {
        __extends(SaveModuleLocks, _super);
        function SaveModuleLocks(taskManager) {
            _super.call(this);
            this._taskManager = taskManager;
        }
        SaveModuleLocks.prototype.process = function (symbol) {
            var _this = this;
            try {
                var repository = new Repository.NavigationRepository();
                this._taskManager.startAsync("Sperren werden gespeichert...", function () {
                    return repository.updateModuleLocksAsync(symbol.item1, symbol.item2)
                        .then(function (result) {
                        _this.output.call({});
                    })
                        .fail(function (exception) {
                        _this.error.call(exception);
                    });
                });
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return SaveModuleLocks;
    }(Parts.Part));
    return SaveModuleLocks;
});

